import styled from 'styled-components/macro';

const ConditionItem = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: .5rem;
`;

export default ConditionItem;
